// Centralized logic for when to show an input error
function hasInputError(meta) {
  var invalid = meta.invalid,
    touched = meta.touched;
  return invalid && touched;
}
export default hasInputError;